import http from 'lib/http';

// 获取行政班列表请求配置
export const urlgetSchoolActivityList = '/api/XOrg/BookMaterial/getSchoolActivityList';

export const urlAddSchoolActivity = '/api/XOrg/BookMaterial/AddSchoolActivity';

export const urlDeleteSchoolActivity = '/api/XOrg/BookMaterial/DeleteSchoolActivity';

export const urlEditSchoolActivity = '/api/XOrg/BookMaterial/EditSchoolActivity';

export const urlAuditingActivity = '/api/XOrg/BookMaterial/AuditingActivity';

export const urlverifyPaper = '/api/XOrg/BookMaterial/verifyPaper';

export interface IgetSchoolCourseList {
  code: string;
  list: {
    id: string;
    activityName: string;
    dateCreated: string;
    activityContent: string;
    dataJson: string;
    voteType: number;
    activityType: number;
    activityState: number;
    activityRemake: string;
    startDate: string;
    endDate: string;
    PaperId: string;
    PaperType: number;
    SourceId: string;
    docJson: string;
    questionType: number;
    CreateDisplayName: string;
    CreateUserId: string;
  }[];
  pagination: {
    totalCount: number;
    pageSize: number;
    pageIndex: number;
  }[];
  msg: string;
}

// 获取行政班列表
export function getSchoolActivityList(schoolCourseId: string,courseId: string , activityType: number, activityName: string, page: number, pageSize: number) {
  return http.post<IgetSchoolCourseList>(urlgetSchoolActivityList, {
    schoolCourseId,
    courseId,
    activityType,
    activityName,
    page,
    pageSize
  });
}

export interface Imsg {
  code: string;
  msg: string;
}

export function AddSchoolActivity(
  schoolCourseId: string,
  courseId: string ,
  activityName: string, 
  activityContent: string, 
  voteType: number, 
  dataJson: string, 
  activityType: string, 
  ActivityRemake: string,
  docJson: string,
  questionType: string,
  userType: number
  ) {
  return http.post<Imsg>(urlAddSchoolActivity, {
    schoolCourseId,
    courseId,
    activityName,
    activityContent,
    voteType,
    dataJson,
    activityType,
    ActivityRemake,
    questionType,
    docJson,
    userType
  })
}

export function DeleteSchoolActivity(Ids: string[]){
  return http.post<Imsg>(urlDeleteSchoolActivity,{
    Ids
  })
}

export function EditSchoolActivity(
  activityId: string,
  activityName: string, 
  activityContent: string, 
  ActivityRemake: string, 
  questionType: number, 
  voteType: number, 
  dataJson: string, 
  docJson: string){
    return http.post<Imsg>(urlEditSchoolActivity,{
      activityId,
      activityName,
      activityContent,
      ActivityRemake,
      questionType,
      voteType,
      dataJson,
      docJson
    })
  }

export function AuditingActivity(ids: string[]){
  return http.post<Imsg>(urlAuditingActivity,{
    ids
  })
}

export function verifyPaper(ids: string[],verifyType: number){
  return http.post<Imsg>(urlverifyPaper,{
    ids,
    verifyType
  })
}
